import React from 'react';
import GridActions from './action/gridActions';
import BuildActions from '../builder/action/builderActions';
import { findIndex } from 'underscore';
import clone from 'clone';
import classNames from 'classnames';
import GridSelect from '../element/gridselect';
import panelActions from './action/panelActions';
import TopBarPanel from './topbarPanel';
import ColumnPanel from './columnPanel';
import BottomBarPanel from './bottombarPanel';
import SortingPanel from './sortingPanel';
import BarAppearance from './barpanel';

class GridPanel extends React.Component {
    constructor(props) {
      super(props);
      this.valueIncrement = this.valueIncrement.bind(this);
      this.valueDecrement = this.valueDecrement.bind(this);
      this.valueIncrementLayout = this.valueIncrementLayout.bind(this);
      this.valueDecrementLayout = this.valueDecrementLayout.bind(this);
      this.handleViewType = this.handleViewType.bind(this);
      this.handleListWrapperClass = this.handleListWrapperClass.bind(this);
      this.metakey = '_reactive_builder_' + this.props.shortcodeKey;
      // API is for few help , just for getting whole post type list
      this.postTypesHelper = API.helper.all_post_types ? API.helper.all_post_types : ['post'];
      this.postTypeOptions = [];
      this.postTypesHelper.forEach((type) => {
        this.postTypeOptions.push({
          value: type,
          label: type,
        });
      });
      this.state = {
        'helperData': clone(this.props.helperData),
        'numberOfPosts': 10,
        'allLayout': clone(this.props.allLayout),
        'activeTap': 'settings',
        'gridWrapperClass': '',
        'listWrapperClass': '',
      };

      this.contents = {
        shortcodeKey: this.props.shortcodeKey,
        uid: this.props.uid,
        save: {},
      };
      this.previewLayouts = {};
      const index = findIndex(this.props.allLayout, { uid: this.props.uid });
      if (index !== -1) {
        this.tempLayouts = clone(this.props.allLayout[index].previewLayouts);
      } else this.tempLayouts = {};
      this.onChangeSelectedImage = this.onChangeSelectedImage.bind(this);
    }
    componentWillMount() {
      this.block = _.where(this.props.allLayout, { uid: this.props.uid });
      if (this.block) {
        this.block = this.block[0];
        this.setState({ ...this.block });
      }
    }
    componentWillReceiveProps(nextProps) {
      this.setState({
        'allLayout': clone(nextProps.allLayout),
      });
    }
    // on save click
    onChangeSelectedImage(ImageId, type) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].previewLayouts = ImageId;
      }
      const pushLayout = {
        'allLayout': clone(allLayout),
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
    }
    handleSubmitLayout() {
      if (_.isEmpty(this.state.allLayout)) {
        return;
      }
      const pushLayout = {
        'allLayout': clone(this.state.allLayout),
        'shortcodeKey': this.props.shortcodeKey,
      };
      BuildActions.saveAllBlocks(pushLayout);
      panelActions.togglePanel('', this.props.shortcodeKey);
    }

    // Note:  per update won't chnage the whole preview , only save button will change the preview .
    updateGridState(fieldKey, e) {
      const content = {};
      content[fieldKey] = e.target.value;
      this.contents.save = { ...this.state, ...content };
      this.contents.save = _.omit(this.contents.save, 'helperData', 'uid', 'layout', 'type');
      GridActions.getBuilderData(this.contents);
      this.setState({ ... content });
    }

    handleChange(val) {
      this.selectedPostTypes = val;
    }

    handleTopBarData(data) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['topbar'] = data;
      }
      this.setState({ allLayout });
    }

    handleColumnData(data) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['column'] = data;
      }
      this.setState({ allLayout });
    }

    handleBottomBarData(data) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['bottombar'] = data;
      }
      this.setState({ allLayout });
    }

    handleSortingData(data) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['sorting'] = data;
      }
      this.setState({ allLayout });
    }
    handleTabChange(view) {
      this.setState({ activeTap: view });
    }
    handleBarData(data) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['bardata'] = data;
      }
      this.setState({ allLayout });
    }

    valueIncrement() {
      let value = null;
      if (this.state.numberOfPosts !== undefined) {
        value = parseInt(this.state.numberOfPosts, 10);
      } else {
        value = 0;
      }
      value += 1;
      const allLayout = clone(this.state.allLayout);
      const index = findIndex(allLayout, { uid: this.props.uid });
      if (index !== -1) {
        allLayout[index].numberOfPosts = value;
        this.setState({ numberOfPosts: value, allLayout });
      }
    }

    valueDecrement() {
      let value = null;
      if (this.state.numberOfPosts !== undefined) {
        value = parseInt(this.state.numberOfPosts, 10);
      } else {
        return;
      }
      if (value === 0) {
        return;
      }
      value -= 1;
      const allLayout = clone(this.state.allLayout);
      const index = findIndex(allLayout, { uid: this.props.uid });
      if (index !== -1) {
        allLayout[index].numberOfPosts = value;
        this.setState({ numberOfPosts: value, allLayout });
      }
    }
    valueIncrementLayout() {
      let value = parseInt(this.state.layout, 10);
      if ((value + 1) > 12) {
        return;
      }
      value += 1;
      const allLayout = clone(this.state.allLayout);
      const index = findIndex(allLayout, { uid: this.props.uid });
      if (index !== -1) {
        allLayout[index].layout = value;
        this.setState({ layout: value, allLayout });
      }
      if (this.layoutType !== undefined) {
        this.setState({ errorMsg: null });
      }
    }
    valueDecrementLayout() {
      let value = parseInt(this.state.layout, 10);
      if ((value - 1) < 1) {
        return;
      }
      value -= 1;
      const allLayout = clone(this.state.allLayout);
      const index = findIndex(allLayout, { uid: this.props.uid });
      if (index !== -1) {
        allLayout[index].layout = value;
        this.setState({ layout: value, allLayout });
      }
      if (this.layoutType !== undefined) {
        this.setState({ errorMsg: null });
      }
    }
    handleViewType(type) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find]['viewType'] = type;
      }
      this.setState({ allLayout });
    }
    handleWrapperClass(value) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].gridWrapperClass = value;
        this.setState({ gridWrapperClass: value, allLayout });
      }
      this.setState({ allLayout });
    }
    handleListWrapperClass(value) {
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      if (find !== -1) {
        allLayout[find].listWrapperClass = value;
        this.setState({ listWrapperClass: value, allLayout });
      }
      this.setState({ allLayout });
    }    
    render() {
      const ImageId = [];
      const allLayout = clone(this.state.allLayout);
      const find = findIndex(allLayout, { uid: this.props.uid });
      let viewType = null;
      if (find !== -1) {
        viewType = allLayout[find].hasOwnProperty('viewType') ? allLayout[find].viewType : null;
        if (allLayout[find].hasOwnProperty('previewLayouts')) {
          ImageId.push(allLayout[find].previewLayouts.toString());
        } else {
          ImageId.push('latestGridLayoutThree');
        }
      }
      let topbarData = null;
      let columnData = null;
      let bottombarData = null;
      let sortingData = null;
      let barData = null;
      if (find !== -1 && allLayout[find]) {
        if ('topbar' in allLayout[find]) {
          topbarData = allLayout[find].topbar;
        }
        if ('bardata' in allLayout[find]) {
          barData = allLayout[find].bardata;
        }
        if ('column' in allLayout[find]) {
          columnData = allLayout[find].column;
        }

        if ('bottombar' in allLayout[find]) {
          bottombarData = allLayout[find].bottombar;
        }

        if ('sorting' in allLayout[find]) {
          sortingData = allLayout[find].sorting;
        }
      }

      const gridPanelClass = classNames({
        'panel-type-body': true,
        'has-postType': !this.props.settingsData.post_type,
      });

      const FilteredImageSelect = (item, index) => {
        item.data.splice(9, 1);
        if (item.data.length !== 0) {
          return (
            <div key = {index}>
              <GridSelect option = {item.data} defaultvalue= {ImageId} onImageSelcted = { this.onChangeSelectedImage } multiselect = "false" />
            </div>
          );
        }
      };
      this.filteredFormatData = [];
      if (this.state.helperData.formats !== undefined || this.state.helperData.formats !== null) {
        this.state.helperData.formats.map((item) => {
          if (item.toString() !== 'standard') {
            return;
          }
          const filteredFormat = {};
          filteredFormat.data = _.where(filteredFormat.data, { type: this.state.postTypes });
          const selfPostType = (this.state.postTypes) ? this.state.postTypes : 'post';
          filteredFormat.data = _.filter(ReactiveLayouts, function (sigleitem) {return sigleitem.type === selfPostType || sigleitem.type === 'all'; });
          if (filteredFormat.data.length === 0) {
            filteredFormat.data = _.where(ReactiveLayouts, { type: 'all' });
          }
          this.filteredFormatData.push(filteredFormat);
        });
      }

      return (<div>
        <button className="layout-save-button" disabled = {this.state.activeTap === 'layout' ? true : false} onClick={this.handleSubmitLayout.bind(this)}><i className="fa fa-floppy-o"></i><span>{API.LANG.SAVE}</span></button>
        <div className="reactive-tab-setting">
          <ul className="nav nav-tabs" role="tablist">
            <li role="presentation" className="active" onClick={this.handleTabChange.bind(this, 'settings')}><a href="#general" aria-controls="general" role="tab" data-toggle="tab">{API.LANG.SETTINGS}</a></li>
            <li role="presentation" onClick={this.handleTabChange.bind(this, 'layout')}><a href="#layout" aria-controls="layout" role="tab" data-toggle="tab">{API.LANG.LAYOUT}</a></li>
            <li role="presentation" onClick={this.handleTabChange.bind(this, 'column')}><a href="#column" aria-controls="column" role="tab" data-toggle="tab">{API.LANG.COLUMN}</a></li>
            <li role="presentation" onClick={this.handleTabChange.bind(this, 'sorting')}><a href="#sorting" aria-controls="layout" role="tab" data-toggle="tab">{API.LANG.SORTING}</a></li>
            <li role="presentation" onClick={this.handleTabChange.bind(this, 'topbar')}><a href="#topbar" aria-controls="topbar" role="tab" data-toggle="tab">{API.LANG.TOP_BAR}</a></li>
            <li role="presentation" onClick={this.handleTabChange.bind(this, 'bottombar')}><a href="#botombar" aria-controls="botombar" role="tab" data-toggle="tab">{API.LANG.BOTTOM_BAR}</a></li>
            <li role="presentation" onClick={this.handleTabChange.bind(this, 'barapps')}><a href="#barapp" aria-controls="barapp" role="tab" data-toggle="tab">{API.LANG.BAR_APPS}</a></li>
          </ul>
          <div className="tab-content">
            <div role="tabpanel" className="tab-pane active" id="general">
              <div className={gridPanelClass}>
                <div className="overlay"></div>
                <div className="flex-row post-type-choose-grid-option">
                  { !this.props.settingsData.post_type && <div className="flex-sm-12 flex-xs-12">
                    <div className="flex-row">
                      <div className="rq-post-type-seletion-first">
                        <i className="fa fa-smile-o"></i>
                        <h4>{API.LANG.SELECT_POST_TYPE_FIRST}.</h4>

                      </div>
                    </div>
                  </div>
                  }
                </div>
              </div>
              <div className="flex-row">
                <div className="flex-sm-5 flex-xs-6">
                  <input type="text" value={this.state.gridWrapperClass} className="reactive-input" onChange={ (node) => { this.handleWrapperClass(node.target.value); }} placeholder={API.LANG.WRAPPER_CLASS_GRID}/>
                </div>
              </div>
              <div className="flex-row">
                <div className="flex-sm-5 flex-xs-6">
                  <input type="text" value={this.state.listWrapperClass} className="reactive-input" onChange={ (node) => { this.handleListWrapperClass(node.target.value); }} placeholder={API.LANG.WRAPPER_CLASS_LIST}/>
                </div>
              </div>
              <div className="grid-choose-option">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.CHANGE_GRID_LAYOUT}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <div className="choose-grid-button">
                      <p><button onClick={ this.valueIncrementLayout }><i className="fa fa-plus"></i></button></p>
                      <p><button onClick={ this.valueDecrementLayout }><i className="fa fa-minus"></i></button></p>
                      <p className="gird-value-count">
                        { this.state.layout !== undefined ? this.state.layout : null }
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="grid-choose-option no-padding">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.NUMBER_OF_POST}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <p><button onClick={ this.valueIncrement }><i className="fa fa-plus"></i></button></p>
                    <p><button onClick={ this.valueDecrement }><i className="fa fa-minus"></i></button></p>
                    <p className="gird-value-count">
                      { this.state.numberOfPosts !== null ? this.state.numberOfPosts : null }
                    </p>
                  </div>
                </div>
              </div>
              <div className="grid-choose-option no-padding">
                <div className="flex-row">
                  <div className="flex-sm-3 flex-xs-12">
                    <span className="caption">{API.LANG.View_Type}</span>
                  </div>
                  <div className="flex-sm-9 flex-xs-12">
                    <p className="defaultGridListView"><button className={viewType === 'grid' ? 'active' : null} onClick={ this.handleViewType.bind(this, 'grid') }>{API.LANG.Grid_View}</button></p>
                    <p className="defaultGridListView"><button className={viewType === 'list' ? 'active' : null} onClick={ this.handleViewType.bind(this, 'list') }>{API.LANG.List_View}</button></p>
                  </div>
                </div>
              </div>
            </div>
            <div role="tabpanel" className="tab-pane" id="layout">
              { this.filteredFormatData.map(FilteredImageSelect) }
            </div>
            <TopBarPanel topbarData={topbarData} onTopBarSubmit={this.handleTopBarData.bind(this)}/>
            <BottomBarPanel bottombarData={bottombarData} onBottomBarSubmit={this.handleBottomBarData.bind(this)} />
            <ColumnPanel {...this.props} columnData={columnData} onColumnSubmit={this.handleColumnData.bind(this)}/>
            <SortingPanel {...this.props} sortingData={sortingData} onSortingSubmit={this.handleSortingData.bind(this)} />
            <BarAppearance {...this.props} barData={barData} appearData={this.handleBarData.bind(this)} />
          </div>
        </div>
      </div>);
    }

}

GridPanel.propTypes = {
  'shortcodeKey': React.PropTypes.number,
  'uid': React.PropTypes.string,
  'allLayout': React.PropTypes.array,
};
export default GridPanel;



// WEBPACK FOOTER //
// ./assets/src/frontend/panel/gridPanel.js